import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import './standardArticleCustom.css';
import StandardArticle from '../standardArticle';
import { CsmSectionLink } from '../../../ui/src/component/csmSectionLink';
import moment from 'moment';
import { calendarTime, getProp } from '../../../ui/src/utilities.js';
import { Pill } from '../../../ui/src/component/pill';

const StandardArticleCustom = props => {
  const {locationSmartTags, isLocationArticle} = props;
  const creationDate = calendarTime(moment(props.article.date));

  let location = getProp(props.article, 'location', []);

  let subtitle = '';
  if (props.author !== null) {
    subtitle = `${props.author.toLocaleUpperCase()}, ${creationDate}`;
  } else if (location.length > 0) {
    subtitle = `${location[0].title.toLocaleUpperCase()}, ${creationDate}`;
  } else {
    subtitle = creationDate;
  }

  let sectionName = getProp(props.article, 'section.name', undefined);
  let section = getProp(props.article, 'section', null);

  const locationIds = getProp(props.article, 'location', []).map(
    location => location.id,
  );

  let pills = []
  if (locationSmartTags) {
    if (!isLocationArticle) {
      pills.push( ...locationSmartTags
      .filter(location => locationIds.includes(location.id))
      .map(location => {
        return (
          <Link style={{ fontSize: 25 }} to={`/lokalita/${location.id}`} key={location.id}>
            <Pill content={location.title} />
          </Link>
        );
      }));
    }

    if(section){
      pills.push(
            <span style={{ fontSize: 25 }}>
              <CsmSectionLink  key={getProp(section, '_id')} section={section}>
                <Pill content={getProp(section, 'name')} />
              </CsmSectionLink>
            </span>
        )
    }
   
}
  return (
    <StandardArticle
      pills={pills}
      article={props.article}
      articleTitleSubtitle={props.articleTitleSubtitleShow ? subtitle : null}
      articleTitleExtra={props.articleTitleExtraShow ? sectionName : null}
      viewCountShow={props.viewCountShow}
      pictureSize={props.pictureSize}
      baseUrl={props.baseUrl}
      imgOverride={props.imgOverride}
      extended={props.extended}
      allowShare={props.allowShare}
      articleAuthorSubtitle={
        section && props.extended ? <CsmSectionLink section={section} /> : null
      }
      size={props.size}
      articleHeadContent={props.articleHeadContent}
    />
  );
};

StandardArticleCustom.defaultProps = {
  viewCountShow: false,
  author: null,
  baseUrl: '',
  extended: false,
  allowShare: true,
  articleTitleSubtitleShow: true,
  articleTitleExtraShow: true,
  isLocationArticle: false,
};

StandardArticleCustom.propTypes = {
  article: PropTypes.object.isRequired,
  viewCountShow: PropTypes.bool,
  pictureSize: PropTypes.number,
  author: PropTypes.string,
  baseUrl: PropTypes.string,
  imgOverride: PropTypes.string,
  extended: PropTypes.bool,
  allowShare: PropTypes.bool,
  size: PropTypes.string,
  articleTitleSubtitleShow: PropTypes.bool,
  articleTitleExtraShow: PropTypes.bool,
  articleHeadContent: PropTypes.node,
  locationSmartTags: PropTypes.array.isRequired,
  isLocationArticle: PropTypes.bool,
};

export default StandardArticleCustom;



// WEBPACK FOOTER //
// ./src/app/component/standardArticleCustom/standardArticleCustom.js